import React from "react";
import ContactDetails from "./ContactDetails";
import ContactHeader from "./ContactHeader";
import Subscribe from "./Subscribe";
import logo from "../images/logo.png";
import { Helmet } from "react-helmet/es/Helmet";

class Contact extends React.Component {
  render() {
    return (
      <div className="animated fadeIn">
        <Helmet>
          <link rel="icon" href={logo} />
          <title>Contact | VehShop</title>
        </Helmet>
        <ContactHeader />
        <ContactDetails />

        <Subscribe />
      </div>
    );
  }
}
export default Contact;
